import { render, staticRenderFns } from "./addCoupon.vue?vue&type=template&id=23a1d5b4&scoped=true"
import script from "./addCoupon.vue?vue&type=script&lang=js"
export * from "./addCoupon.vue?vue&type=script&lang=js"
import style0 from "@wangeditor/editor/dist/css/style.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./addCoupon.vue?vue&type=style&index=1&id=23a1d5b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a1d5b4",
  null
  
)

export default component.exports